import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";

import {getTranslation} from "../../helpers/get-translation";


const styles = theme => ({
	imageContainer:{
		textAlign: "center",
		marginBottom: '15px',
		"& img": {
			width: 'auto',
			height: "75px",
			verticalAlign: "middle"
		},
		"& span":{
			fontSize: '32px',
		},
	},
	imageText:{
		maxHeight: '26px',
		marginLeft: '10px',
	}
});


function LoginLogo(props) {
	const { classes } = props;

	return (
		<div className={classes.imageContainer}>
			<img src={getTranslation("image_login_screen_logo")}/>
			<img src={getTranslation("image_login_screen_logo_string")} className={classes.imageText}/>
		</div>
	)
}

LoginLogo.propTypes = {
	classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LoginLogo);